import "./App.scss";
import "./styles/setup-bulma.scss";

import { useEffect } from "react";
import { Route, Routes } from "react-router-dom";
import { setLocale, setTranslations } from "react-i18nify";
import { AuthenticatedTemplate, UnauthenticatedTemplate } from "@azure/msal-react";
import { useAppDispatch } from "./app/hooks";
import { NavItems } from "./common/helpers/navigation";
import { UserAccountClaims } from "./common/pages/userAccountClaims";
import { updateGlobalSettings } from "./common/store/globalSettingsSlice";
import { RootPage } from "./features/admin/pages/rootPage";
import { AssessmentExamineeLanding } from "./features/assessment/pages/assessmentExamineeLanding";
import { SignupLanding } from "./features/signup/pages/signupLanding";
import { en, es } from "./lang";
import { useQuery } from "./utils/useQuery";
import { MainRoot } from "@fadmin/tabs/main/pages/MainRoot";
import { LanguageProvider } from "./lang/useLanguage";
import { PurchaseLanding } from "./features/purchase/pages/purchaseLanding";
import { AppInsightsContext, AppInsightsErrorBoundary } from "@microsoft/applicationinsights-react-js";
import { reactPlugin } from "./AppInsights";
import { ErrorMessage } from "@components/ErrorMessage";
import APIErrorProvider from "@services/APIErrorProvider";
import Login from "@fadmin/components/Login";
import { AppLogin } from "@fadmin/pages/appLogin";

function App(): JSX.Element {
    setTranslations({ en, es });

    const dispatch = useAppDispatch();
    const { allParams } = useQuery();

    useEffect(() => {
        dispatch(updateGlobalSettings(allParams));
        setLocale("en");
    }, []);

    return (
        <AppInsightsErrorBoundary
            onError={() => <h1>Something went wrong please try again</h1>}
            appInsights={reactPlugin}
        >
            <LanguageProvider>
                <div>
                    <AppInsightsContext.Provider value={reactPlugin}>
                        <APIErrorProvider>
                            <ErrorMessage />
                            <AuthenticatedTemplate>
                                <UserAccountClaims />
                                <Routes>
                                    <Route path={NavItems.Main.Root.wildcardPath} element={<MainRoot />} />
                                    <Route path={NavItems.Signup.Landing.wildcardPath} element={<SignupLanding />} />
                                    <Route path={NavItems.Login.Landing.path} element={<Login />} />
                                </Routes>
                            </AuthenticatedTemplate>
                            <UnauthenticatedTemplate>
                                <Routes>
                                    <Route path="/" element={<AppLogin />} />
                                    <Route path={NavItems.Signup.Landing.wildcardPath} element={<SignupLanding />} />
                                    <Route
                                        path={NavItems.Assessments.Landing.wildcardPath}
                                        element={<AssessmentExamineeLanding />}
                                    />

                                    <Route
                                        path={NavItems.Purchase.Landing.wildcardPath}
                                        element={<PurchaseLanding />}
                                    />

                                    <Route path={"*"} element={<RootPage />} />
                                </Routes>
                            </UnauthenticatedTemplate>
                        </APIErrorProvider>
                    </AppInsightsContext.Provider>
                </div>
            </LanguageProvider>
        </AppInsightsErrorBoundary>
    );
}

export default App;
